import { CustomValuesEditField } from "PFApp/components/custom_values_edit_field";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { ChangeRequestCustomField, PureCustomValueData } from "PFCore/types";
import { useState } from "react";

type ReviewCustomFieldProps = {
  customField: ChangeRequestCustomField;
  handleChange: (values: ChangeRequestCustomField["values"]) => void;
  error?: string;
};

export const ReviewCustomField = ({ customField, handleChange, error }: ReviewCustomFieldProps) => {
  const { getCustomTypeByName } = useCustomTypes();
  const { name } = customField.type;
  const customType = getCustomTypeByName(name);

  const [values, setValues] = useState<PureCustomValueData[]>(
    customField.values.map(({ value, global_id }) => ({
      id: global_id || value,
      text: value
    }))
  );
  const multi = customType?.kind === "multiple";
  const suggestion = customType?.suggestion_description;

  return (
    <div data-qa-id={`Onboarding.ReviewCustomField.${customType?.name}`}>
      <CustomValuesEditField
        customType={customType || null}
        multi={multi}
        values={values}
        label={customType?.display_as}
        errors={error}
        handleChange={(data) => {
          setValues(data);
          handleChange(data.map(({ text }) => ({ value: String(text) || "" })));
        }}
        qaIdPrefix="ReviewCustomField"
        placeholder={multi || values.length === 0 ? suggestion : undefined}
        forceUnlocked
      />
    </div>
  );
};
